module.exports = __webpack_public_path__ + "img/Kanpa Iyakiniku.e7cec386.svg";